import React from "react";
import Earn from "./Earn/Earn";

function ReferEarn() {
    return(
        <>
            <Earn />
        </>
    )
}

export default ReferEarn;